import { FC, ReactElement, useEffect, useRef, useState } from "react";
import { fetchAsync, postAsync, postWithoutSign } from "../services/ApiHandler";
import { PromptHintSet } from "../model/PromptHintSet";
import { PromptHint } from "../model/PromptHint";
import { useLocation } from "react-router";
import { GenerationRequest } from "../model/GenerationRequest";
import { ModerationLabel } from "../model/ModerationLabel";

export const GenerationDetailPage: FC = () => {
  
  const query = new URLSearchParams(useLocation().search);
  const [requestId, setRequestId] = useState(query.get('request-id') as string);
  const [request, setRequest] = useState<GenerationRequest | undefined>(undefined);
  const [moderationList, setModerationList] = useState<ModerationLabel[]>([]);
  
  useEffect(() => {
    fetchMainTasteList();
    fetchModerationLabels();
  }, []);

  async function fetchMainTasteList (){
    var param = { id: requestId };
    const response = await fetchAsync<GenerationRequest>(`Generation/GetGeneratedImageDetail`, param);
    setRequest(response);
  };


  async function fetchModerationLabels (){
    var param = { requestId: requestId };
    const response = await fetchAsync<ModerationLabel[]>(`ModerationLabels/GetList`, param);
    setModerationList(response);
  };


  function buildDetailRow(title: String, value: String) {
    return <>
    <div className="text-left mb-6">
      <div className="mb-1">{title}</div>
      <div className="text-sm border rounded px-1 py-1 min-h-[24px]">{value}</div>
    </div>
    </>
  }

  return <>
    { request && 
    <div className="text-center mt-12 ml-8 pb-16">
      <div>
        <img className="w-[600px] min-w-[600px]" src={`${process.env.REACT_APP_IMAGE_URL}/${request.requestId}`}></img>
      </div>
      <div className="mt-4">
        { buildDetailRow('Model', request.model) }
        { buildDetailRow('Seed', request.seed.toString()) }
        { buildDetailRow('NSFW', request.isNsfw == 0 ? "True" : "False") }
        { buildDetailRow('Prompt', request.prompt) }
        { buildDetailRow('Negative Prompt', request.negativePrompt) }
        { buildDetailRow('Prompt (default)', request.defaultPrompt) }
        { buildDetailRow('Negative Prompt (default)', request.defaultNegativePrompt) }
        { buildDetailRow('Prompt (Addtional)', request.additionalPrompt) }
        { buildDetailRow('Negative Prompt (Addtional)', request.additionalNegativePrompt) }
      </div>
      <hr></hr>
      <div className="text-left mb-4">Moderation Check Result</div>
      { moderationList.map(item =>
          buildDetailRow("",  `confidence: ${item.confidence}, name: ${item.name}`)
      )} 
    </div>
    }
  </>;
}